import NotFoundContainer from "./containers/NotFoundContainer";

export default {
  path: "*",
  components: { main: NotFoundContainer, category: null }
};



// WEBPACK FOOTER //
// ./src/routes/404/index.js